var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdatetest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "update-arrows-svgrepo-com 1",
    clipPath: "url(#clip0_138_334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.99 3.00769L10.7121 4.29094C11.5685 5.1478 12.043 6.28741 12.043 7.49997C12.043 9.99941 10.0112 12.0312 7.51172 12.0312V11.125L5.69922 12.9375L7.51172 14.75V13.8437C11.0094 13.8437 13.8555 10.9976 13.8555 7.49997C13.8555 5.80257 13.1935 4.20757 11.99 3.00769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.32422 2.0625L7.51172 0.25V1.15625C4.01405 1.15625 1.16797 4.00233 1.16797 7.5C1.16797 9.19741 1.82998 10.7924 3.03348 11.9923L4.3113 10.709C3.45489 9.85217 2.98047 8.71256 2.98047 7.5C2.98047 5.00056 5.01228 2.96875 7.51172 2.96875V3.875L9.32422 2.0625Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5,
    height: 14.5,
    fill: "white",
    transform: "translate(0.261719 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatetest);
export default __webpack_public_path__ + "static/media/updatetest.3d9374aac111c8d655aa1d189d2a8ca5.svg";
export { ForwardRef as ReactComponent };